/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : App.tsx
// 설명 : React 애플리케이션의 루트 컴포넌트
//  - React Router를 사용하여 페이지 간 라우팅을 설정합니다.
//  - TranslationProvider로 애플리케이션을 감싸 다국어 지원을 제공합니다.
// 최종수정일 : 2025-08-12
/////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 사용자정의 모듈
//   번역, 레이아웃, 페이지 컴포넌트, 메인프레임
////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { TranslationProvider } from './translations';
import Layout from './Layout';
import LoginPage from './pages/LoginPage';
import MainFrame from './pages/mainFrame';
import { ModalProvider } from "./components/CommonModal";
import { ResizablePaper } from './components/ResizablePopup';

// MUI 테마 - 대표색/의미색을 색 토큰(styles/tokensV1.css)과 같은 값으로 맞춤(라이트 전용)
const theme = createTheme({
  palette: {
    primary: { main: '#2563eb', dark: '#1d4ed8', light: '#60a5fa' },
    info: { main: '#2563eb' },
    success: { main: '#16a34a' },
    warning: { main: '#d97706' },
    error: { main: '#dc2626' },
  },
  components: {
    // 모든 Dialog 팝업 : 오른쪽 아래 모서리를 끌어 크기 조절(2026-10-18, components/ResizablePopup.tsx)
    MuiDialog: { defaultProps: { PaperComponent: ResizablePaper } },
  },
});

////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// 메인컴포넌트 : App
////////////////////////////////////////////////////////////////////////////////////////////////////////////
const App: React.FC = () => {
  return (
    <TranslationProvider>
      <ThemeProvider theme={theme}>
        <ModalProvider>
          <Router>
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route path="/main" element={<Layout />}>
                <Route index element={<MainFrame />} />
              </Route>
            </Routes>
          </Router>
        </ModalProvider>
      </ThemeProvider>
    </TranslationProvider>
  );
};

export default App;
